import { Metadata } from "@ciam/analytics";
export type CIAMContextType = {
  config: CIAMConfig,
  children?: React.ReactNode,
  ciamSession?: CIAMSession,
  logOut?: (skipLogoutRedirect?: boolean, inactivity?: boolean) => void,
  loadChallenge?: (callbackObj: CallbackObj | undefined) => void,
  reverseSso?: (responseObj: any, onValidationSuccess: (responseObj: any) => void, onValidationFailure: (errorObj: any, jwtResponseObject: any) => void) => void,
  tag?: (metadata: Metadata) => void
};

export interface CallbackObj {
  callback?: (response: any) => void
};

export interface CIAMConfig {
  env:
    | 'it1'
    | 'it2'
    | 'it3'
    | 'it4'
    | 'it5'
    | 'dev1'
    | 'dev2'
    | 'dev3'
    | 'dev4'
    | 'dev5'
    | 'uat1'
    | 'uat2'
    | 'uat3'
    | 'uat4'
    | 'uat5'
    | 'prod'
    | 'prod1'
    | 'prd'
    | 'local';
  appId: 'smb' | 'avvance' | 'insights' | 'ciam';
  appHome: string;
  appLogin: string;
  debugMode?: boolean;
  initialExtendTime?: number;
  idleTime?: number;
  popupTimer?: number;
  logoutCallBack?: () => void;
  refreshCallBack?: (token: string) => void;
  initCallBack?: (session: CIAMSession) => void;
  reverseSsoCallBack?: (responseObj: any, errorObj?: any) => void;
  internalUrl?: boolean;
  enableCrossDomain?: boolean;
  showLoading?: boolean;
  whitelistUrls?: string[];
}

export interface CIAMSession {
  jwtToken?: string;
  refreshToken?: string;
  appName?: string;
  accessToken?: string;
  ciamUser?: CIAMUser;
  userGUID?: string;
  users?: string;
  currentSession?: string;
}

// @types.todo.ts
export interface CIAMUser {
  Email?: string | undefined;
  iss?: string | undefined;
  iat?: number | undefined;
  exp?: number | undefined;
  aud?: string | string[] | undefined;
  sub?: string | undefined;
  GivenName?: string | undefined;
  Surname?: string | undefined;
  Role?: Array<string> | undefined | [];
  did?: string | undefined;
  dsid?: string | undefined;
  custom_data?: { at: string };
}

export const configMap = {
  it : {
    JS_LOGGER_DOMAIN_URL: "https://it2-onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://it1-transec.usbank.com",
    ROUTING_KEY: "IT2",
    HEADER_AK: "3eVYJfbOuOG2acIb2mg9Wn264d9PMTAh",
    HANDLE_ROUTE: "https://it.login.elavon.com/v1/api/router/",
    SESSION_SUPPORT: "https://it.login.elavon.com/v1/api/sessionsupport/",
    MANIFEST_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 
  it2 : {
    JS_LOGGER_DOMAIN_URL: "https://it2-onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://it1-transec.usbank.com",
    ROUTING_KEY: "IT2",
    HEADER_AK: "3eVYJfbOuOG2acIb2mg9Wn264d9PMTAh",
    HANDLE_ROUTE: "https://it2.login.elavon.com/v1/api/router/",
    SESSION_SUPPORT: "https://it.login.elavon.com/v1/api/sessionsupport/",
    MANIFEST_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 
  dev: {
    JS_LOGGER_DOMAIN_URL: "https://it2-onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://it1-transec.usbank.com",
    ROUTING_KEY: "IT2",
    HEADER_AK: "3eVYJfbOuOG2acIb2mg9Wn264d9PMTAh",
    HANDLE_ROUTE: "https://it-paymentsinsider.us.bank-dns.com/v1/api/router/",
    SESSION_SUPPORT: "https://it-api-elavon.us.bank-dns.com/v1/api/sessionsupport",
    MANIFEST_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 
  uat: {
    JS_LOGGER_DOMAIN_URL: "https://uat2-onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://uat1-transec.usbank.com",
    ROUTING_KEY: "UAT2",
    HEADER_AK: "asHr0AavNAnfxzDeYhAt2DIoFb3Cr6j3",
    HANDLE_ROUTE: "https://uat.login.elavon.com/v1/api/router/",
    SESSION_SUPPORT: "https://uat.login.elavon.com/v1/api/sessionsupport/",
    MANIFEST_PATH: "https://uat1-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://uat1-onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 
  prod: {
    JS_LOGGER_DOMAIN_URL: "https://onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://transec.usbank.com",
    ROUTING_KEY: "DEFAULT",
    HEADER_AK: "6ThXDjYuLNVyuz93ex3xP63hzgEV2jTu",
    HANDLE_ROUTE: "https://login.elavon.com/v1/api/router/",
    SESSION_SUPPORT: "https://login.elavon.com/v1/api/sessionsupport/",
    MANIFEST_PATH: "https://onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 
  local: {
    JS_LOGGER_DOMAIN_URL: "https://it2-onlinebanking.usbank.com",
    TRANSMIT_CONFIG_URL: "https://it1-transec.usbank.com",
    ROUTING_KEY: "IT2",
    HEADER_AK: "3eVYJfbOuOG2acIb2mg9Wn264d9PMTAh",
    HANDLE_ROUTE: "http://localhost:8081/v1/api/router/",
    SESSION_SUPPORT: "http://localhost:8082/v1/api/sessionsupport/",
    MANIFEST_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/es/latest/manifest.json",
    MANIFEST_LOGOUT_PATH: "https://it1-onlinebanking.usbank.com/digital/auth/challenge/latest/manifest.json"
  }, 

}